(() => {
  const header = document.querySelector('[data-header]');
  const nav = document.querySelector('[data-nav]');
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const searchForm = document.querySelector('[data-search-form]');
  const searchInput = searchForm?.querySelector('input[type="search"]');
  const suggestions = document.querySelector('[data-search-suggest]');
  const searchResults = suggestions?.querySelector('[data-search-results]');
  const searchStatus = suggestions?.querySelector('[data-search-status]');
  const searchAll = suggestions?.querySelector('[data-search-all]');
  const toast = document.querySelector('[data-toast]');

  const notify = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(notify.timer);
    notify.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  if (header) {
    const setHeaderState = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  }

  menuToggle?.addEventListener('click', () => {
    if (!nav) return;
    const open = nav.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  });

  const megaMenus = [...document.querySelectorAll('.nav-mega')];
  megaMenus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      megaMenus.forEach((other) => { if (other !== menu) other.open = false; });
    });
  });
  document.addEventListener('click', (event) => {
    if (megaMenus.some((menu) => menu.contains(event.target))) return;
    megaMenus.forEach((menu) => { menu.open = false; });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    megaMenus.forEach((menu) => { menu.open = false; });
  });

  document.querySelectorAll('[data-mobile-search]').forEach((button) => {
    button.addEventListener('click', () => {
      if (!searchForm) {
        window.location.href = document.body.dataset.searchUrl || '/search';
        return;
      }
      searchForm.classList.toggle('is-mobile-open');
      if (searchForm.classList.contains('is-mobile-open')) searchInput?.focus();
    });
  });

  let searchTimer;
  let searchRequest;
  let searchOptions = [];
  let searchOptionIndex = -1;
  const closeSearchSuggestions = () => {
    if (!suggestions || !searchInput) return;
    suggestions.hidden = true;
    searchInput.setAttribute('aria-expanded', 'false');
    searchInput.removeAttribute('aria-activedescendant');
    searchOptionIndex = -1;
  };
  const openSearchSuggestions = () => {
    if (!suggestions || !searchInput) return;
    suggestions.hidden = false;
    searchInput.setAttribute('aria-expanded', 'true');
  };
  const normalizeOemCode = (value) => String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  const oemSearchMatches = (query) => {
    const normalizedQuery = normalizeOemCode(query);
    if (normalizedQuery.length < 4 || !Array.isArray(window.ID24OEMSearchIndex)) return [];
    return window.ID24OEMSearchIndex
      .map((product) => {
        const codes = Array.isArray(product.normalized_codes) ? product.normalized_codes : [];
        const exactIndex = codes.findIndex((code) => code === normalizedQuery);
        const prefixIndex = normalizedQuery.length >= 5
          ? codes.findIndex((code) => code.startsWith(normalizedQuery) || normalizedQuery.startsWith(code))
          : -1;
        const matchIndex = exactIndex >= 0 ? exactIndex : prefixIndex;
        if (matchIndex < 0) return null;
        const rawCode = product.codes?.[matchIndex] || query;
        return {
          ...product,
          match_label: `Réf. OEM : ${rawCode}`,
          _oem_exact: exactIndex >= 0,
        };
      })
      .filter(Boolean)
      .sort((left, right) => Number(right._oem_exact) - Number(left._oem_exact))
      .slice(0, 7);
  };
  const mergeSearchProducts = (nativeProducts, oemProducts) => {
    const merged = [];
    const urls = new Set();
    [...oemProducts, ...nativeProducts].forEach((product) => {
      const key = String(product.url || '').split('?')[0];
      if (!key || urls.has(key)) return;
      urls.add(key);
      merged.push(product);
    });
    return merged.slice(0, 7);
  };
  const renderSearchProducts = (products, query) => {
    if (!searchResults || !searchStatus || !searchAll) return;
    searchResults.textContent = '';
    searchOptions = [];
    searchOptionIndex = -1;
    if (!products.length) {
      searchStatus.hidden = false;
      searchStatus.textContent = `Aucun injecteur trouvé pour « ${query} ».`;
      searchAll.hidden = true;
      return;
    }
    searchStatus.hidden = true;
    products.forEach((product, index) => {
      const link = document.createElement('a');
      link.className = 'search-suggest__product';
      link.href = product.url;
      link.id = `header-search-option-${index}`;
      link.setAttribute('role', 'option');
      link.setAttribute('aria-selected', 'false');
      const imageUrl = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image?.url;
      if (imageUrl) {
        const image = document.createElement('img');
        image.src = `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}width=120`;
        image.alt = '';
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'search-suggest__placeholder';
        placeholder.textContent = 'ID24';
        link.appendChild(placeholder);
      }
      const copy = document.createElement('span');
      const title = document.createElement('strong');
      title.textContent = product.title;
      const price = document.createElement('small');
      price.textContent = product.match_label || product.price || '';
      copy.append(title, price);
      const arrow = document.createElement('b');
      arrow.textContent = '→';
      link.append(copy, arrow);
      searchResults.appendChild(link);
      searchOptions.push(link);
    });
    searchAll.href = `${searchForm.action}?type=product&q=${encodeURIComponent(query)}`;
    searchAll.hidden = false;
  };
  const fetchSearchSuggestions = async () => {
    if (!searchForm || !searchInput || !searchStatus || !searchResults) return;
    const query = searchInput.value.trim();
    openSearchSuggestions();
    if (query.length < 2) {
      searchRequest?.abort();
      searchResults.textContent = '';
      searchStatus.hidden = false;
      searchStatus.textContent = 'Saisissez au moins 2 caractères.';
      if (searchAll) searchAll.hidden = true;
      return;
    }
    searchRequest?.abort();
    searchRequest = new AbortController();
    searchStatus.hidden = false;
    searchStatus.textContent = 'Recherche dans le catalogue…';
    const oemProducts = oemSearchMatches(query);
    try {
      const endpoint = searchForm.dataset.predictiveUrl || '/search/suggest';
      const url = `${endpoint}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=hide`;
      const response = await fetch(url, { headers: { Accept: 'application/json' }, signal: searchRequest.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const payload = await response.json();
      const products = payload.resources?.results?.products || [];
      renderSearchProducts(mergeSearchProducts(products, oemProducts), query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      if (oemProducts.length) {
        renderSearchProducts(oemProducts, query);
        return;
      }
      searchResults.textContent = '';
      searchStatus.hidden = false;
      searchStatus.textContent = 'La recherche instantanée est indisponible. Appuyez sur Entrée pour rechercher.';
      if (searchAll) searchAll.hidden = true;
    }
  };
  searchInput?.addEventListener('focus', () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(fetchSearchSuggestions, 0);
  });
  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchTimer = window.setTimeout(fetchSearchSuggestions, 180);
  });
  searchInput?.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeSearchSuggestions();
      return;
    }
    if (!searchOptions.length || !['ArrowDown', 'ArrowUp'].includes(event.key)) return;
    event.preventDefault();
    searchOptions[searchOptionIndex]?.setAttribute('aria-selected', 'false');
    searchOptionIndex = event.key === 'ArrowDown'
      ? (searchOptionIndex + 1) % searchOptions.length
      : (searchOptionIndex - 1 + searchOptions.length) % searchOptions.length;
    const activeOption = searchOptions[searchOptionIndex];
    activeOption.setAttribute('aria-selected', 'true');
    searchInput.setAttribute('aria-activedescendant', activeOption.id);
    activeOption.scrollIntoView({ block: 'nearest' });
  });
  searchForm?.addEventListener('submit', (event) => {
    const exactMatches = oemSearchMatches(searchInput?.value || '').filter((product) => product._oem_exact);
    const exactUrls = [...new Set(exactMatches.map((product) => product.url))];
    if (exactUrls.length !== 1) return;
    event.preventDefault();
    window.location.href = exactUrls[0];
  });
  document.addEventListener('click', (event) => {
    if (searchForm && suggestions && !searchForm.contains(event.target)) closeSearchSuggestions();
  });

  document.querySelector('[data-focus-reference]')?.addEventListener('click', () => {
    window.setTimeout(() => document.querySelector('#reference')?.focus(), 250);
  });

  const galleryMain = document.querySelector('[data-gallery-main]');
  const galleryModal = document.querySelector('[data-gallery-modal]');
  const galleryModalImage = document.querySelector('[data-gallery-modal-image]');
  const galleryThumbs = [...document.querySelectorAll('[data-gallery-thumb]')];
  let galleryIndex = Math.max(0, galleryThumbs.findIndex((button) => button.classList.contains('is-active')));

  const updateGalleryFit = () => {
    if (!galleryMain || !galleryMain.naturalWidth || !galleryMain.naturalHeight) return;
    galleryMain.classList.toggle('is-landscape', galleryMain.naturalWidth / galleryMain.naturalHeight > 1.28);
  };
  if (galleryMain?.complete) updateGalleryFit();
  galleryMain?.addEventListener('load', updateGalleryFit);

  const showGalleryImage = (button, shouldFocus = false) => {
    if (!button || !galleryMain || !button.dataset.gallerySrc) return;
    galleryThumbs.forEach((item) => item.classList.toggle('is-active', item === button));
    galleryIndex = Math.max(0, galleryThumbs.indexOf(button));
    galleryMain.src = button.dataset.gallerySrc;
    galleryMain.removeAttribute('srcset');
    galleryMain.alt = button.dataset.galleryAlt || galleryMain.alt;
    const thumbRail = button.parentElement;
    if (thumbRail) thumbRail.scrollTo({ left: Math.max(0, button.offsetLeft - 12), behavior: 'smooth' });
    if (shouldFocus) button.focus({ preventScroll: true });
  };

  galleryThumbs.forEach((button) => button.addEventListener('click', () => showGalleryImage(button)));
  document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => {
    if (!galleryThumbs.length) return;
    showGalleryImage(galleryThumbs[(galleryIndex - 1 + galleryThumbs.length) % galleryThumbs.length]);
  });
  document.querySelector('[data-gallery-next]')?.addEventListener('click', () => {
    if (!galleryThumbs.length) return;
    showGalleryImage(galleryThumbs[(galleryIndex + 1) % galleryThumbs.length]);
  });

  document.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
    if (!galleryModal || !galleryMain || !galleryModalImage) return;
    galleryModalImage.src = galleryMain.currentSrc || galleryMain.src;
    galleryModal.hidden = false;
    document.body.style.overflow = 'hidden';
  });

  const closeGallery = () => {
    if (!galleryModal) return;
    galleryModal.hidden = true;
    document.body.style.overflow = '';
  };
  document.querySelector('[data-gallery-close]')?.addEventListener('click', closeGallery);
  galleryModal?.addEventListener('click', (event) => { if (event.target === galleryModal) closeGallery(); });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeGallery(); });

  const collectionFilters = document.querySelector('[data-collection-filters]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterOverlay = document.querySelector('.collection-filter-overlay');
  const setFiltersOpen = (open) => {
    if (!collectionFilters || !filterToggle || !filterOverlay) return;
    collectionFilters.classList.toggle('is-open', open);
    filterToggle.setAttribute('aria-expanded', String(open));
    filterOverlay.hidden = !open;
    document.body.classList.toggle('filters-open', open);
  };
  filterToggle?.addEventListener('click', () => setFiltersOpen(true));
  document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', () => setFiltersOpen(false)));

  const productForm = document.querySelector('[data-product-form]');
  const variantInputs = [...document.querySelectorAll('[data-variant-picker] input[name="id"]')];
  const quantityInput = document.querySelector('[data-quantity]');
  const priceOutput = document.querySelector('[data-current-price]');
  const addTotal = document.querySelector('[data-add-total]');
  const addButton = document.querySelector('[data-add-detail]');
  const addLabel = addButton?.querySelector('.add-to-cart__label');
  const purchaseRow = document.querySelector('.purchase-row');
  const stickyCart = document.querySelector('[data-mobile-sticky-cart]');
  const stickyButton = stickyCart?.querySelector('[data-sticky-add]');
  const stickyLabel = stickyCart?.querySelector('[data-sticky-label]');
  const stickyTotal = stickyCart?.querySelector('[data-sticky-total]');
  const stickyVariantSelect = stickyCart?.querySelector('[data-sticky-variant-select]');
  const stickyQuantity = stickyCart?.querySelector('[data-sticky-quantity]');
  const stickyQuantityMinus = stickyCart?.querySelector('[data-sticky-quantity-minus]');
  const stickyQuantityPlus = stickyCart?.querySelector('[data-sticky-quantity-plus]');

  const currency = window.Shopify?.currency?.active || 'EUR';
  const formatMoney = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(cents / 100);
  const selectedVariant = () => variantInputs.find((input) => input.checked) || variantInputs[0];

  const updateProductState = () => {
    const variant = selectedVariant();
    if (!variant) return;
    const price = Number(variant.dataset.price || 0);
    const quantity = Math.max(1, Number(quantityInput?.value || 1));
    const available = variant.dataset.available === 'true';
    const formatted = formatMoney(price);
    const total = formatMoney(price * quantity);

    variantInputs.forEach((input) => input.closest('.variant-option')?.classList.toggle('is-selected', input === variant));
    if (priceOutput) priceOutput.textContent = formatted;
    if (addTotal) addTotal.textContent = total;
    if (addButton) addButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    if (stickyTotal) stickyTotal.textContent = total;
    if (stickyButton) stickyButton.disabled = !available;
    if (stickyLabel) stickyLabel.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    if (stickyVariantSelect) stickyVariantSelect.value = variant.value;
    if (stickyQuantity) stickyQuantity.textContent = String(quantity);

    if (variant.dataset.mediaId) {
      const variantThumb = galleryThumbs.find((button) => button.dataset.galleryMediaId === variant.dataset.mediaId);
      if (variantThumb) showGalleryImage(variantThumb);
    } else if (galleryMain && variant.dataset.imageUrl) {
      galleryMain.src = variant.dataset.imageUrl;
      galleryMain.removeAttribute('srcset');
      galleryMain.alt = variant.dataset.imageAlt || galleryMain.alt;
    }
  };

  variantInputs.forEach((input) => input.addEventListener('change', updateProductState));
  document.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = String(Math.max(1, Number(quantityInput.value) - 1));
    updateProductState();
  });
  document.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = String(Math.min(9, Number(quantityInput.value) + 1));
    updateProductState();
  });
  quantityInput?.addEventListener('change', updateProductState);
  stickyVariantSelect?.addEventListener('change', () => {
    const variant = variantInputs.find((input) => input.value === stickyVariantSelect.value && !input.disabled);
    if (!variant) return;
    variant.checked = true;
    variant.dispatchEvent(new Event('change', { bubbles: true }));
  });
  stickyQuantityMinus?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = String(Math.max(1, Number(quantityInput.value) - 1));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
  stickyQuantityPlus?.addEventListener('click', () => {
    if (!quantityInput) return;
    quantityInput.value = String(Math.min(9, Number(quantityInput.value) + 1));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
  productForm?.addEventListener('submit', () => {
    if (addButton) addButton.classList.add('is-loading');
    if (addLabel) addLabel.textContent = 'Ajout en cours…';
    if (stickyButton) stickyButton.classList.add('is-loading');
    if (stickyLabel) stickyLabel.textContent = 'Ajout en cours…';
  });
  stickyButton?.addEventListener('click', () => {
    if (!productForm || stickyButton.disabled) return;
    if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
    else addButton?.click();
  });
  if (stickyCart && productForm && purchaseRow) {
    stickyCart.hidden = false;
    const setStickyCartVisible = (visible) => {
      stickyCart.classList.toggle('is-visible', visible);
      stickyCart.setAttribute('aria-hidden', String(!visible));
      if (stickyButton) stickyButton.tabIndex = visible ? 0 : -1;
    };
    if ('IntersectionObserver' in window) {
      const purchaseObserver = new IntersectionObserver(([entry]) => setStickyCartVisible(!entry.isIntersecting), { threshold: 0.15 });
      purchaseObserver.observe(purchaseRow);
    } else {
      const updateStickyVisibility = () => {
        const bounds = purchaseRow.getBoundingClientRect();
        setStickyCartVisible(bounds.bottom < 0 || bounds.top > window.innerHeight);
      };
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);
      updateStickyVisibility();
    }
  }
  updateProductState();

  document.querySelectorAll('[data-copy-promo]').forEach((button) => {
    button.addEventListener('click', async () => {
      const code = button.dataset.copyPromo || '';
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        notify(`Code ${code} copié`);
      } catch (_) {
        notify(`Code promo : ${code}`);
      }
    });
  });

  const productTabs = document.querySelector('[data-product-tabs]');
  const productTabButtons = [...document.querySelectorAll('[data-product-tab]')];
  const productTabPanels = [...document.querySelectorAll('[data-product-panel]')];
  const activateProductTab = (key, shouldScroll = false) => {
    if (!key) return;
    productTabButtons.forEach((button) => {
      const active = button.dataset.productTab === key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', String(active));
    });
    productTabPanels.forEach((panel) => {
      const active = panel.dataset.productPanel === key;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    if (shouldScroll) productTabs?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  productTabButtons.forEach((button) => button.addEventListener('click', () => activateProductTab(button.dataset.productTab)));
  document.querySelectorAll('[data-open-product-tab]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      activateProductTab(link.dataset.openProductTab, true);
    });
  });

  document.querySelectorAll('.rte a').forEach((link) => {
    if (link.hostname && link.hostname !== window.location.hostname) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });

  const productReviewWidget = document.querySelector('[data-product-review-widget]');
  const productReviewJson = document.querySelector('[data-product-review-json]');
  if (productReviewWidget && productReviewJson) {
    try {
      const reviewData = JSON.parse(productReviewJson.textContent || '{}');
      const reviews = Array.isArray(reviewData.reviews) ? reviewData.reviews : [];
      const reviewCount = Number(reviewData.number_of_reviews || reviews.length || 0);
      const average = Number(reviewData.average_rating || 0);
      if (!reviews.length || !reviewCount) {
        document.querySelector('[data-product-review-section]')?.remove();
      } else {
        const stars = (score, label) => {
          const element = document.createElement('span');
          element.className = 'id24-stars';
          element.setAttribute('role', 'img');
          element.setAttribute('aria-label', label || `${score.toFixed(1)} étoiles sur 5`);
          for (let index = 1; index <= 5; index += 1) {
            const star = document.createElement('i');
            star.className = score >= index ? 'is-on' : score >= index - 0.5 ? 'is-half' : 'is-off';
            star.textContent = '★';
            element.appendChild(star);
          }
          return element;
        };
        const summary = document.createElement('div');
        summary.className = 'product-review-summary-card';
        const score = document.createElement('strong');
        score.textContent = average.toLocaleString('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        const summaryCopy = document.createElement('div');
        summaryCopy.append(stars(average));
        const count = document.createElement('span');
        count.textContent = `${reviewCount} avis client${reviewCount > 1 ? 's' : ''} sur ce produit`;
        summaryCopy.appendChild(count);
        summary.append(score, summaryCopy);

        const viewport = document.createElement('div');
        viewport.className = 'product-review-viewport';
        const track = document.createElement('div');
        track.className = 'product-review-track';
        reviews.forEach((review) => {
          const card = document.createElement('article');
          card.className = 'product-review-card';
          const top = document.createElement('div');
          top.className = 'product-review-card__top';
          top.appendChild(stars(Number(review.rating || 0), `${review.rating} étoiles sur 5`));
          const verified = document.createElement('span');
          verified.textContent = review.verified_buyer ? 'Achat vérifié' : 'Avis client';
          top.appendChild(verified);
          const body = document.createElement('p');
          body.textContent = review.body || review.title || '';
          const footer = document.createElement('footer');
          const avatar = document.createElement('span');
          avatar.className = 'product-review-avatar';
          avatar.textContent = (review.reviewer_initial || review.reviewer_name?.charAt(0) || '✓').toUpperCase();
          const identity = document.createElement('div');
          const name = document.createElement('strong');
          name.textContent = review.reviewer_name || 'Client vérifié';
          const date = document.createElement('small');
          const createdAt = review.created_at ? new Date(review.created_at) : null;
          date.textContent = createdAt && !Number.isNaN(createdAt.valueOf())
            ? createdAt.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })
            : 'Avis vérifié';
          identity.append(name, date);
          footer.append(avatar, identity);
          card.append(top, body, footer);
          track.appendChild(card);
        });
        viewport.appendChild(track);

        const navigation = document.createElement('div');
        navigation.className = 'product-review-navigation';
        const previous = document.createElement('button');
        previous.type = 'button';
        previous.setAttribute('aria-label', 'Avis précédent');
        previous.textContent = '←';
        const counter = document.createElement('span');
        const next = document.createElement('button');
        next.type = 'button';
        next.setAttribute('aria-label', 'Avis suivant');
        next.textContent = '→';
        navigation.append(previous, counter, next);
        let reviewIndex = 0;
        const cards = [...track.children];
        const updateReview = (index) => {
          reviewIndex = (index + cards.length) % cards.length;
          track.scrollTo({ left: cards[reviewIndex].offsetLeft, behavior: 'smooth' });
          counter.textContent = `${reviewIndex + 1} / ${cards.length}`;
        };
        previous.addEventListener('click', () => updateReview(reviewIndex - 1));
        next.addEventListener('click', () => updateReview(reviewIndex + 1));
        track.addEventListener('scroll', () => {
          const closest = cards.reduce((best, card, index) => {
            const distance = Math.abs(card.offsetLeft - track.scrollLeft);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Number.POSITIVE_INFINITY });
          reviewIndex = closest.index;
          counter.textContent = `${reviewIndex + 1} / ${cards.length}`;
        }, { passive: true });
        counter.textContent = `1 / ${cards.length}`;
        productReviewWidget.append(summary, viewport);
        if (cards.length > 1) productReviewWidget.appendChild(navigation);
      }
    } catch (_) {
      document.querySelector('[data-product-review-section]')?.remove();
    }
  }

  const fiveStarSection = document.querySelector('[data-five-star-reviews]');
  if (fiveStarSection) {
    const reviewCards = [...fiveStarSection.querySelectorAll('.jdgm-carousel-item')];
    const fiveStarCards = reviewCards.filter((card) => {
      const rating = card.querySelector('.jdgm-carousel-item__review-rating');
      const label = (rating?.getAttribute('aria-label') || '').trim();
      const score = Number(rating?.dataset.score || label.match(/\d+(?:[.,]\d+)?/)?.[0]?.replace(',', '.') || 0);
      return score === 5;
    });
    reviewCards.forEach((card) => {
      if (!fiveStarCards.includes(card)) card.remove();
    });
    const normalizeReviewProductTitle = (value = '') => value
      .replace(/œ/gi, 'oe')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
    const productMap = window.ID24ReviewProductMap?.products || {};

    fiveStarCards.forEach((card, index) => {
      card.dataset.reviewIndex = String(index);
      const rating = card.querySelector('.jdgm-carousel-item__review-rating');
      rating?.setAttribute('aria-label', '5 étoiles sur 5');

      const originalProduct = card.querySelector('.jdgm-carousel-item__product');
      const image = originalProduct?.querySelector('img');
      if (image?.dataset.src && !image.getAttribute('src')) image.src = image.dataset.src;
      const productTitle = (image?.alt || '').trim();
      const productHandle = productMap[normalizeReviewProductTitle(productTitle)];
      if (productTitle && productHandle) {
        const productLink = document.createElement('a');
        productLink.className = 'id24-review-product';
        productLink.href = `/products/${encodeURIComponent(productHandle)}`;
        if (image?.src) {
          const productImage = image.cloneNode(true);
          productImage.removeAttribute('style');
          productImage.loading = 'lazy';
          productLink.append(productImage);
        }
        const productCopy = document.createElement('span');
        productCopy.innerHTML = `<small>Produit évalué</small><strong></strong>`;
        productCopy.querySelector('strong').textContent = productTitle;
        productLink.append(productCopy);
        productLink.insertAdjacentHTML('beforeend', '<b aria-hidden="true">→</b>');
        card.querySelector('.jdgm-carousel-item__review')?.insertAdjacentElement('afterend', productLink);
      } else {
        const storeBadge = document.createElement('span');
        storeBadge.className = 'id24-review-store-badge';
        storeBadge.textContent = 'Avis sur la boutique';
        card.querySelector('.jdgm-carousel-item__review')?.insertAdjacentElement('afterend', storeBadge);
      }

      const reviewer = card.querySelector('.jdgm-carousel-item__reviewer-name-wrapper');
      const reviewerName = (card.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent || 'Client vérifié').trim();
      if (reviewer) {
        const initials = reviewerName === 'Anonyme'
          ? '✓'
          : reviewerName.split(/\s+/).slice(0, 2).map((part) => part[0]).join('').toUpperCase();
        reviewer.innerHTML = '';
        const avatar = document.createElement('span');
        avatar.className = 'id24-review-avatar';
        avatar.setAttribute('aria-hidden', 'true');
        avatar.textContent = initials || '✓';
        const identity = document.createElement('span');
        identity.className = 'id24-review-identity';
        const name = document.createElement('strong');
        name.textContent = reviewerName;
        const verified = document.createElement('small');
        verified.textContent = 'Avis client vérifié';
        identity.append(name, verified);
        reviewer.append(avatar, identity);
      }
    });

    const track = fiveStarSection.querySelector('.jdgm-carousel__item-wrapper');
    const counter = fiveStarSection.querySelector('[data-review-counter]');
    const progress = fiveStarSection.querySelector('[data-review-progress]');
    const previous = fiveStarSection.querySelector('[data-review-prev]');
    const next = fiveStarSection.querySelector('[data-review-next]');
    let activeReview = 0;
    let pauseUntil = 0;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const updateReviewNavigation = () => {
      if (!track || !fiveStarCards.length) return;
      const closest = fiveStarCards.reduce((best, card, index) => {
        const distance = Math.abs(card.offsetLeft - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY });
      activeReview = closest.index;
      if (counter) counter.textContent = `${String(activeReview + 1).padStart(2, '0')} / ${String(fiveStarCards.length).padStart(2, '0')}`;
      if (progress) progress.style.width = `${((activeReview + 1) / fiveStarCards.length) * 100}%`;
    };
    const showReview = (index, userInitiated = false) => {
      if (!track || !fiveStarCards.length) return;
      activeReview = (index + fiveStarCards.length) % fiveStarCards.length;
      if (userInitiated) pauseUntil = Date.now() + 9000;
      track.scrollTo({ left: fiveStarCards[activeReview].offsetLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      window.setTimeout(updateReviewNavigation, prefersReducedMotion ? 0 : 380);
    };
    previous?.addEventListener('click', () => showReview(activeReview - 1, true));
    next?.addEventListener('click', () => showReview(activeReview + 1, true));
    track?.addEventListener('scroll', () => window.requestAnimationFrame(updateReviewNavigation), { passive: true });
    track?.addEventListener('pointerdown', () => { pauseUntil = Date.now() + 9000; }, { passive: true });
    track?.addEventListener('focusin', () => { pauseUntil = Date.now() + 9000; });
    if (!prefersReducedMotion && fiveStarCards.length > 1) {
      window.setInterval(() => {
        if (document.hidden || Date.now() < pauseUntil || fiveStarSection.matches(':hover')) return;
        showReview(activeReview + 1);
      }, 5200);
    }
    window.addEventListener('resize', updateReviewNavigation, { passive: true });
    updateReviewNavigation();

    if (fiveStarCards.length && track) fiveStarSection.hidden = false;
    else fiveStarSection.remove();
  }

  if (window.location.hash === '#reference') document.querySelector('#reference')?.focus();
  window.InjecteurDiesel24 = { notify };
})();
